<script>
export default {
  props: ['model', 'html', 'title', 'tamanho'],
  data () {
    return {
      visualiza: false
    }
  },
  created () {
    this.visualiza = this.model
  },
  methods: {
    onClose () {
      this.$emit('close')
    }
  },
  watch: {
    visualiza (newValue, oldValue) {
      if (oldValue === true && newValue === false) this.onClose()
    },
    model (newValue) {
      this.visualiza = newValue
    },
    html (newValue) {
      let html = newValue || ``
      this.$refs.iframeModal.contentDocument.open()
      this.$refs.iframeModal.contentDocument.write()
      this.$refs.iframeModal.contentDocument.write(html)
      this.$refs.iframeModal.contentDocument.close()
    }
  }
}
</script>
<template>
  <div>
    <b-modal :title="title" v-model="visualiza" class='modal-primary'  :hide-footer="true" :class="tamanho">
      <div class="content-iframe">
        <iframe ref="iframeModal" style="height:100%;width:100%;border:0;"></iframe>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>
.content-iframe {
  height: 560px;
}
</style>



// WEBPACK FOOTER //
// super-modal.vue?98f8ec70